import React, { useEffect } from 'react';
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Ecosystem from "./pages/Ecosystem";
import Program from "./pages/Program";
import Contact from "./pages/Contact";
import Media from "./pages/Media";
import BelajarIslam from "./pages/BelajarIslam";
import Infografis from "./pages/belajar-islam/Infografis";
import Artikel from "./pages/belajar-islam/Artikel";
import PanduanIbadah from "./pages/belajar-islam/PanduanIbadah";
import DoaDzikir from "./pages/belajar-islam/DoaDzikir";
import Kajian from "./pages/belajar-islam/Kajian";
import { Toaster } from "@/components/ui/sonner";
import WelcomePopup from "./components/WelcomePopup";

// Scroll to top component
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App bg-[#081c1a] min-h-screen text-[#F2F2F0]">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/ecosystem" element={<Ecosystem />} />
          <Route path="/program" element={<Program />} />
          <Route path="/media" element={<Media />} />
          <Route path="/contact" element={<Contact />} />
          {/* Belajar Islam Routes */}
          <Route path="/belajar-islam" element={<BelajarIslam />} />
          <Route path="/belajar-islam/infografis" element={<Infografis />} />
          <Route path="/belajar-islam/artikel" element={<Artikel />} />
          <Route path="/belajar-islam/panduan-ibadah" element={<PanduanIbadah />} />
          <Route path="/belajar-islam/doa-dzikir" element={<DoaDzikir />} />
          <Route path="/belajar-islam/kajian" element={<Kajian />} />
        </Routes>
        <Footer />
        <WelcomePopup />
        <Toaster position="bottom-right" theme="dark" />
      </BrowserRouter>
    </div>
  );
}

export default App;
